import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import path from 'path';

import {
  SystemMessageStyled,
  Anchor,
  Kbd,
} from 'libs/rendering/gltf/components/systemMessage/systemMessage.styled';

export const NoViewer = withNamespaces()(
  observer(props => {
    if (props.file) {
      const extension = path.extname(props.file.filename).replace('.', '');
      return (
        <SystemMessageStyled type='info'>
          <Trans>
            <strong>Sorry, we don&#39;t currently support </strong>
            <Kbd type='info'>.{extension}</Kbd>
            <strong>files.</strong> Want us to add support?{' '}
            <Anchor
              href={`mailto:hello@wikifactory.com?Subject=Previewing ".${extension}" files on Wikifactory`}
            >
              Let us know!
            </Anchor>
          </Trans>
        </SystemMessageStyled>
      );
    } else {
      return (
        <SystemMessageStyled type='error'>
          <Trans>
            <strong>Sorry, but there is a problem displaying this file.</strong>
          </Trans>
        </SystemMessageStyled>
      );
    }
  }),
);

NoViewer.propTypes = {
  name: PropTypes.string,
  file: PropTypes.object,
};

export const NoGltfSemver = withNamespaces()(
  observer(props => {
    const semver = props.file?.conversionGltfjson?.viewerSemver;
    return (
      <SystemMessageStyled type='info'>
        <Trans>
          <strong>Sorry, viewer</strong> <Kbd type='info'>{semver}</Kbd>
          <strong>is currently not available.</strong>
        </Trans>
      </SystemMessageStyled>
    );
  }),
);

NoGltfSemver.propTypes = {
  name: PropTypes.string,
  file: PropTypes.object,
};
